<mat-dialog-content>
  <h2 mat-dialog-title>
    {{ 'AUTOMATIONS.CONTINUE_ON_NEW_STEP.SELECT_STEP' | translate }}
  </h2>
  <div class="dialog-content">
    <EXP__glxy-wrap dense>
      <mat-form-field>
        <mat-select
          [required]="true"
          [formControl]="selectedStepControl"
          placeholder="{{ 'AUTOMATIONS.CONTINUE_ON_NEW_STEP.SELECT_STEP_DROPDOWN' | translate }}*"
        >
          <ng-container *ngFor="let option of data.nextStepOptions">
            <mat-option [value]="option.id">
              {{ option.name | translate }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <mat-hint>
        {{ 'AUTOMATIONS.CONTINUE_ON_NEW_STEP.SELECT_STEP_HINT' | translate }}
      </mat-hint>
    </EXP__glxy-wrap>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close [disabled]="processing">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="continueOnNewStep()"
    [disabled]="processing || selectedStepControl.value === ''"
  >
    {{ 'AUTOMATIONS.CONTINUE_ON_NEW_STEP.CONTINUE_ON_SELECTED_STEP' | translate }}
  </button>
</mat-dialog-actions>
